import {
  GET_LIST_CHECKTHONGTINKH,
  GET_LIST_CHECKTHONGTINKH_SUCCESS,
  GET_LIST_CHECKTHONGTINKH_FAILURE,
} from "./actionTypes";

export const getListCheckThongTinKh = (dataSearch) => ({
  type: GET_LIST_CHECKTHONGTINKH,
  dataSearch,
});

export const getListCheckThongTinKhSuccess = (data) => ({
  type: GET_LIST_CHECKTHONGTINKH_SUCCESS,
  payload: data,
});

export const getListCheckThongTinKhFailure = () => ({
  type: GET_LIST_CHECKTHONGTINKH_FAILURE,
});
